/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type RoutePlanFeedbackChangeTagEnum =
  (typeof RoutePlanFeedbackChangeTagEnum)[keyof typeof RoutePlanFeedbackChangeTagEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RoutePlanFeedbackChangeTagEnum = {
  OtherFieldTester: 0,
  LegOrder: 1,
  DayTooLong: 2,
  DayTooShort: 3,
  Transfer: 4,
  TimesDoNotHold: 5,
  ShouldBeManual: 6,
  GapSolution: 7,
  Other: 99,
} as const;
